import { createReducer, PayloadAction } from '@reduxjs/toolkit';

import {
    fetchMfaSetupRequest,
    fetchMfaSetupSuccess,
    fetchMfaSetupFailure,
    postMfaVerificationRequest,
    postMfaVerificationSuccess,
    postMfaVerificationFailure,
} from '@actions/mfa';
import { MfaSetupKey } from '@_types/shared/Mfa';
import { postLoginSuccess } from '@actions/auth/postLogin';

interface MFAState {
    setupKey: MfaSetupKey | null;
    isFetching: boolean;
    isPosting: boolean;
    fetchError: string | null;
    postError: string | null;
    postSuccess: boolean;
}

const initialState: MFAState = {
    setupKey: null,
    isFetching: false,
    isPosting: false,
    fetchError: null,
    postError: null,
    postSuccess: false,
};

export default createReducer(initialState, {
    [postLoginSuccess.type]: () => initialState,
    [fetchMfaSetupRequest.type]: handleFetchRequest,
    [fetchMfaSetupSuccess.type]: handleFetchSuccess,
    [fetchMfaSetupFailure.type]: handleFetchFailure,
    [postMfaVerificationRequest.type]: handlePostRequest,
    [postMfaVerificationSuccess.type]: handlePostSuccess,
    [postMfaVerificationFailure.type]: handlePostFailure,
});

function handleFetchRequest(state: MFAState) {
    state.isFetching = true;
    state.fetchError = null;
}

function handleFetchSuccess(state: MFAState, action: PayloadAction<MfaSetupKey>) {
    state.isFetching = false;
    state.setupKey = action.payload;
}

function handleFetchFailure(state: MFAState, action: PayloadAction<string>) {
    state.isFetching = false;
    state.fetchError = action.payload;
}

function handlePostRequest(state: MFAState) {
    state.isPosting = true;
    state.postSuccess = false;
    state.postError = null;
}

function handlePostSuccess(state: MFAState) {
    state.isPosting = false;
    state.postSuccess = true;
}

function handlePostFailure(state: MFAState, action: PayloadAction<string>) {
    state.isPosting = false;
    state.postError = action.payload;
}
